export default __webpack_public_path__ + "static/media/loadingImg.6fca17cd.gif";